"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_TICKET_REQUEST_USER_SATISFACTION = exports.ITOP_TICKET_REQUEST_USER_SATISFACTION_MAP = exports.ITOP_TICKET_REQUEST_RESOLUTION_CODE = exports.ITOP_TICKET_REQUEST_ESCALATION_FLAG = exports.ITOP_TICKET_REQUEST_ORIGIN = exports.ITOP_TICKET_REQUEST_PRIORITY = exports.ITOP_TICKET_REQUEST_REQUEST_TYPE = exports.ITOP_TICKET_REQUEST_STATUS = void 0;
exports.ITOP_TICKET_REQUEST_STATUS = {
    APPROVED: 'approved',
    ASSIGNED: 'assigned',
    CLOSED: 'closed',
    ESCALATED_TTO: 'escalated_tto',
    ESCALATED_TTR: 'escalated_ttr',
    NEW: 'new',
    PENDING: 'pending',
    REJECTED: 'rejected',
    RESOLVED: 'resolved',
    WAITING_FOR_APPROVAL: 'waiting_for_approval',
};
/** TicketRequest's Request Types */
exports.ITOP_TICKET_REQUEST_REQUEST_TYPE = {
    SERVICE_REQUEST: 'service_request',
};
/**
 * NOTE: DID NOT FIND ANY VALUES TO MAP THESE NUMBERS TO
 */
exports.ITOP_TICKET_REQUEST_PRIORITY = {
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
};
exports.ITOP_TICKET_REQUEST_ORIGIN = {
    INTRANET: 'intranet',
    MAIL: 'mail',
    PHONE: 'phone',
    PORTAL: 'portal',
};
exports.ITOP_TICKET_REQUEST_ESCALATION_FLAG = {
    YES: 'yes',
    NO: 'no',
};
exports.ITOP_TICKET_REQUEST_RESOLUTION_CODE = {
    ASSISTANCE: 'assistance',
    BUG_FIXED: 'bug fixed',
    HARDWARE_REPAIR: 'hardware repair',
    OTHER: 'other',
    SOFTWARE_PATCH: 'software patch',
    SYSTEM_UPDATE: 'system update',
    TRAINING: 'training',
};
exports.ITOP_TICKET_REQUEST_USER_SATISFACTION_MAP = {
    1: 'Muy Satisfecho',
    2: 'Satisfecho',
    3: 'Insatisfecho',
    4: 'Muy Insatisfecho',
};
exports.ITOP_TICKET_REQUEST_USER_SATISFACTION = {
    MUY_SATISFECHO: 1,
    SATISFECHO: 2,
    INSATISFECHO: 3,
    MUY_INSATISFECHO: 4,
};
